import React, { useState } from "react";
import styles from "./AdminAnalyticsReports.module.css";
import HeaderComponent from "../../../../components/HeaderComponent/HeaderComponent";
import MyLineChart from "./LineChart/LineChart";
import BarChart from "../../AdminDashboard/BarChart/BarChart";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend,
} from "chart.js";
import { Line, Bar, Doughnut } from "react-chartjs-2";
import { TextComponent } from "../../../../components";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  BarElement,
  ArcElement,
  Tooltip,
  Legend
);

const AdminAnalyticsReports = () => {
  const [chartData, setChartData] = useState({
    labels: ["15%", "17%", "21%", "25%", "21%", "21%"],
    datasets: [
      {
        label: "Wheat",
        data: [15, 18, 7, 21, 25, 25],
        backgroundColor: [
          "#C74D52",
          "#FB9A68",
          "#C74D52",
          "#822D12",
          "#F39C12",
          "#AB3006",
        ],
        borderRadius: 10,
        borderColor: "transparent",
        barPercentage: 0.7,
        categoryPercentage: 0.5,
      },
    ],
  });

  // ===== Production Chart =====
  const productionData = {
    labels: ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"],
    datasets: [
      {
        label: "Production",
        data: [1100, 1400, 1650, 1180, 1300, 1600, 1800],
        borderColor: "#27AE60",
        backgroundColor: "rgba(255, 165, 0, 0.4)",
        tension: 0.4,
        fill: true,
      },
    ],
  };

  const productionOptions = {
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      y: { beginAtZero: true },
    },
  };

  // ===== Station Activity Chart =====
  const stationData = {
    labels: ["Mixing", "Proofing", "Oven", "Cooling", "Packaging"],
    datasets: [
      {
        label: "Number of Tasks",
        data: [320, 290, 270, 260, 250],
        borderRadius: 5,

        backgroundColor: [
          "#A04000",
          "#E67E22",
          "#EB984E",
          "#F5CBA7",
          "#FDEBD0",
        ],
      },
    ],
  };

  const stationOptions = {
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      y: {
        grid: {
          display: false,
          drawBorder: false,
        },
        beginAtZero: true,
      },
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        ticks: {
          font: { size: 14 },
        },
      },
    },
  };

  // ===== Orders by Customer Chart =====
  const ordersData = {
    labels: [
      "Customer E",
      "Customer D",
      "Customer C",
      "Customer B",
      "Customer A",
    ],
    datasets: [
      {
        label: "Orders",
        data: [20, 30, 25, 50, 35],
        borderRadius: 16,
        backgroundColor: ["#FEB376", "#AB3006"],
      },
    ],
  };

  const ordersOptions = {
    indexAxis: "y",
    responsive: true,
    plugins: { legend: { display: false } },
    scales: {
      x: {
        grid: {
          display: false,
          drawBorder: false,
        },
        beginAtZero: true,
      },
    },
  };

  // ===== Waste Tracking Chart =====
  const wasteData = {
    labels: ["Burnt", "Expired", "Damaged", "Overproduction", "Other"],
    datasets: [
      {
        data: [35, 20, 15, 25, 10],
        backgroundColor: [
          "#E74C3C",
          "#E67E22",
          "#F1C40F",
          "#27AE60",
          "#3498DB",
        ],
        borderWidth: 0,
      },
    ],
  };

  const wasteOptions = {
    plugins: { legend: { position: "right" } },
    cutout: "70%",
  };

  return (
    <div className={styles.mainCont}>
      <HeaderComponent heading={"Analytics & Reporting"} showBackIcon={false} />
      <div className={styles.subCont}>
        <div className={styles.TopDivs}>
          <div className={styles.Col}>
            <TextComponent text={"Production"} className={styles.Heading} />
            <div className={styles.LineChart}>
              <Line data={productionData} options={productionOptions} />
            </div>
          </div>
          <div className={styles.Col}>
            <TextComponent
              text={"Station Activity"}
              className={styles.Heading}
            />

            <div className={styles.barChart}>
              <Bar data={stationData} options={stationOptions} />
            </div>
          </div>
        </div>
        <div className={styles.BottomDivs}>
          <div className={styles.Col}>
            <TextComponent
              text={"Orders by Customer"}
              className={styles.Heading}
            />

            <div className={styles.BarChart2}>
              <Bar data={ordersData} options={ordersOptions} />
            </div>
          </div>
          <div className={styles.Col}>
            <TextComponent text={"Waste Tracking"} className={styles.Heading} />

            <div className={styles.Doughnut}>
              <Doughnut data={wasteData} options={wasteOptions} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AdminAnalyticsReports;
